import { getHdc1Dot5MembershipId } from "../builders/getHdc1Dot5MembershipId";
import { getHdc1Dot5MembershipDetails } from "../builders/getHdc1Dot5MembershipDetails";
import { getMockPolicies } from "../builders/getMockPolicies";
import { omniCanadaVipMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

export const sidneyCrosby: MockPersona = {
  key: "sidneyCrosby",
  name: "Sidney Crosby",
  description: "🇨🇦 | Single Enthusiast+ policy | HDC 1.5 VIP | No alerts/autopay successful",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: getMockPolicies("apexCan003"),
      },
    },
    hdc: {
      fetch1Dot5MembershipId: getHdc1Dot5MembershipId("HDC01981376"),
      fetch1Dot5MembershipDetails: getHdc1Dot5MembershipDetails({
        level: 4, // TODO: Is this VIP?
      }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "sidney@crosby.com",
            firstName: "Sidney",
            middleName: "",
            lastName: "Crosby",
            mailingAddress: {
              line1: "1286 Cole Harbour Rd",
              line2: "",
              city: "Cole Harbour",
              state: "NS",
              postalCode: "B2V 1N3",
              country: "CANADA",
            },
            preferredPhone: "9023719472",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000025",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: omniCanadaVipMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
